import React, {Fragment, useEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {translateRecord} from "../../../common/utils";
import Dish from "./Dish";
import {useDispatch, useSelector} from "react-redux";
import Loading from "../../../common/Loading";
import {getCategoryAction, getCategoryDishesAction} from "../../../../store/actions/RestaurantActions";

const Category = (props) => {
  const { t } = useTranslation();
  const category = props.category;
  const storeOrders = useSelector(store => store.orders);
  const store = useSelector(store => store.restaurants);
  const hiddenNavRef = useRef(null);
  const navRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  });

  useEffect(() => {
    const forScroll = !!props.refs.current[category.id] ? props.refs.current[category.id].offsetTop - (!!props.company ? 230 : 85) : 70;
    if (!!category.subItems) {
      window.scrollTo({
        top: forScroll,
        left: 0,
        behavior: "smooth",
      });
    } else {
      if (!!props.company) {
        dispatch(getCategoryAction(props.company, props.restaurant, store.selectedCategory, category)).then(() => {
          window.scrollTo({
            top: forScroll,
            left: 0,
            behavior: "smooth",
          });
        })
      } else {
        dispatch(getCategoryDishesAction(props.restaurant, category)).then(() => {
          window.scrollTo({
            top: forScroll,
            left: 0,
            behavior: "smooth",
          });
        })
      }
    }
  }, [props.restaurant.slug, store.selectedCategory, props.category]);

  function filterDish(d) {
    return ((props.fromDashboard || variationsAvailable(d) || (!d.available && (!!d.not_available_text || !!d.not_available_text_en))) &&
      (['on_table', 'to_visit'].includes(storeOrders.orderCheckout.selectedOrderType) ||
        (['to_go', 'delivery'].includes(storeOrders.orderCheckout.selectedOrderType) && d.packable)));
  }

  function variationsAvailable(dish) {
    const variations = Object.values(dish.dish_variations);
    if (variations.length > 0) {
      return dish.available && variations.filter((v) => !v.available).length !== variations.length
    } else {
      return dish.available
    }
  }

  function defaultSubCategory(category) {
    const availableDishes = category.subItems.filter((d) => d.available);
    if (storeOrders.orderCheckout.selectedOrderType === 'to_go' || storeOrders.orderCheckout.selectedOrderType === 'delivery') {
      const packable = availableDishes.filter((d) => d.packable).map((d) => d.sub_category_id);
      return category.sub_categories.filter((sc) => packable.includes(sc.id)).sort((a,b) => a.position - b.position)[0].id
    } else {
      const available = availableDishes.map((d) => d.sub_category_id);
      return category.sub_categories.filter((sc) => available.includes(sc.id)).sort((a,b) => a.position - b.position)[0].id
    }
  }

  const isSticky = () => {
    const scrollTop = window.scrollY;
    if (!!hiddenNavRef.current) {
      if (scrollTop > hiddenNavRef.current.offsetTop - (!!props.company ? (props.singleCategory ? 227 : 268) : 125)) {
        hiddenNavRef.current.style.height = '57px';
        navRef.current.classList.add(!!props.company ? 'is-sticky-company-nav-tab' : 'is-sticky-nav-tab');
        if (!!props.company) {
          if (props.singleCategory) {
            navRef.current.style.top = '227px';
          }
        }
      } else {
        hiddenNavRef.current.style.height = 0;
        navRef.current.classList.remove(!!props.company ? 'is-sticky-company-nav-tab' : 'is-sticky-nav-tab');
      }
    }
  };

  return (
    <>
      { !!category.subItems ?
        <div>
          { category.sub_categories.length > 0 ?
            <div>
              <div style={{height: 0}} ref={hiddenNavRef}/>
              <div className='subcategories' ref={navRef}>
                { category.sub_categories.sort((a,b) => a.position - b.position).map((size, i) => {
                  return (
                    <Fragment key={i}>
                      { category.subItems.filter((d) => d.sub_category_id === size.id &&
                        (['to_go', 'delivery'].includes(storeOrders.orderCheckout.selectedOrderType) ?
                          d.packable : true) && variationsAvailable(d)).length > 0 &&
                      <div className='subcategory mr-2'
                           onClick={() => {
                             props.setState({...props.state, selectedSubcategory: size.id});
                             let delta = 130;
                             if (!!props.company) {
                               if (props.singleCategory) {
                                 delta = 230;
                               } else {
                                 delta = 268;
                               }
                             }
                             window.scrollTo({
                               top: hiddenNavRef.current.offsetTop - delta,
                               left: 0,
                               behavior: "smooth",
                             })
                           }}
                      >
                        <span className={`nav-link ${(category.sub_categories.map((s) => s.id).includes(props.selectedSubcategory) ?
                          size.id === props.selectedSubcategory
                          :
                          size.id === defaultSubCategory(category)) && 'active'}`}
                        >
                          {translateRecord(size, 'name')}
                        </span>
                      </div>}
                    </Fragment>)})}
              </div>
              <div className='py-0'>
                { !!category.description && category.description.length > 0 && !props.noPhoto &&
                  <div className='order-dish' style={{minHeight: 'unset'}}>
                    <span className='text-black'>{translateRecord(category, 'description')}</span>
                  </div>}
                <div className="card-body p-0">
                  <div className='row'>
                    { category.subItems.filter((d) => { return category.sub_categories.map((s) => s.id).includes(props.selectedSubcategory) ?
                      d.sub_category_id === props.selectedSubcategory
                      :
                      d.sub_category_id === defaultSubCategory(category)})
                      .sort((a,b) => a.position - b.position).map((d, index) =>
                        <Fragment key={index}>
                          { filterDish(d) &&
                          <div className='col-lg-4 col-md-6'>
                            <Dish dish={d} handleDishOrderCount={props.handleDishOrderCount}
                                    handleAddDishToOrder={props.handleAddDishToOrder}
                                    selectDishVariation={props.selectDishVariation}
                                    selectComplexDish={props.selectComplexDish}
                                    dishParameter={props.dishParameter} index={index}
                                    variationsAvailable={variationsAvailable}
                                    calculateCount={props.calculateCount} noPhoto={props.noPhoto}
                                    table={props.table} fromDashboard={props.fromDashboard}
                                    acceptOutsideOrders={props.acceptOutsideOrders}
                                    countDishVariation={props.countDishVariation}
                                    category={category} restaurant={props.restaurant}/>
                          </div>}
                        </Fragment>)}
                  </div>
                </div>
              </div>
            </div>
          :
            <div className='mt-2'>
              { !!category.description && category.description.length > 0 && !props.noPhoto &&
                <div className='order-dish' style={{minHeight: 'unset'}}>
                  <span className='text-black'>{translateRecord(category, 'description')}</span>
                </div>}
              <div className="card-body p-0">
                <div className='row'>
                  { category.subItems.sort((a,b) => a.position - b.position).map((d, index) =>
                    <Fragment key={index}>
                      { filterDish(d) &&
                      <div className='col-lg-4 col-md-6'>
                        <Dish dish={d} handleDishOrderCount={props.handleDishOrderCount}
                                handleAddDishToOrder={props.handleAddDishToOrder}
                                selectDishVariation={props.selectDishVariation}
                                selectComplexDish={props.selectComplexDish}
                                countDishVariation={props.countDishVariation}
                                dishParameter={props.dishParameter} index={index}
                                variationsAvailable={variationsAvailable}
                                calculateCount={props.calculateCount} noPhoto={props.noPhoto}
                                table={props.table} fromDashboard={props.fromDashboard}
                                acceptOutsideOrders={props.acceptOutsideOrders}
                                category={category} restaurant={props.restaurant}/>
                      </div>}
                    </Fragment>)}
                </div>
              </div>
            </div>}
        </div>
      :
        <Loading/>}
    </>
  );
};

export default Category;
